export const getGAIDFromCookie = () => {
	const GACookie = document.cookie.match(/_ga=(.+?);/)
	if (GACookie && GACookie.length > 1) {
		return GACookie[1].split('.').slice(-2).join('.')
	}
}